<template>
  <form ref="form" class="p-2" @submit.prevent="handleForm">
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-40">
        <md-field :class="getValidationClass('titulo')">
          <label :for="`titulo${_uid}`">Titulo</label>
          <md-input
            :id="`titulo${_uid}`"
            v-model.trim="form.titulo"
            :name="`titulo${_uid}`"
          />
          <span v-if="!$v.form.titulo.required" class="md-error"
            >Titulo é requerido</span
          >
        </md-field>
      </div>

      <div
        class="md-layout-item"
        :class="{
          'md-size-40': showFormComando,
          'md-size': !showFormComando,
        }"
      >
        <md-field v-if="showFormComando" :class="getValidationClass('comando')">
          <label :for="`comando${_uid}`">Comando</label>
          <md-select
            :id="`comando${_uid}`"
            v-model="form.comando"
            :name="`comando${_uid}`"
            @md-selected="$emit('change', { comando: form.comando })"
          >
            <md-option
              v-for="(key, value) in comandosTitulo"
              :key="key"
              :value="value"
            >
              {{ key }}
            </md-option>
          </md-select>
          <span v-if="!$v.form.comando.required" class="md-error"
            >Comando é requerido</span
          >
        </md-field>

        <div v-else style="text-align: left; color: red">
          <p class="md-error">
            Deve-se adicionar comandos para esse equipamento
          </p>
        </div>
      </div>

      <div v-if="showFormComando" class="md-layout-item md-size-10">
        <md-button class="md-icon-button mt-3 md-primary" type="submit">
          <md-icon>edit</md-icon>
        </md-button>
      </div>
    </div>
  </form>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'MotoBombaComandoForm',
  mixins: [validationMixin],
  props: {
    comandosTitulo: {
      type: Object,
      required: true,
    },
    comando: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    form: {
      titulo: null,
      comando: null,
    },
  }),
  validations: {
    form: {
      titulo: {
        required,
      },
      comando: {
        required,
      },
    },
  },
  computed: {
    showFormComando() {
      return Object.keys(this.comandosTitulo).length !== 0
    },
  },
  beforeMount() {
    this.form = {
      titulo: this.comando.titulo,
      comando: this.comando.comando,
    }
  },
  methods: {
    handleForm() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('change', { ...this.form })
    },
  },
}
</script>
